import React, { useContext, useEffect } from "react";
import { Overall } from "../../../../styles/ListingStyles";
import { useRouter } from "next/router";
import Head from "next/head";
import { Spinner, Box, Flex } from "@chakra-ui/react";
global.XMLHttpRequest = require("xhr2");
import ListingComponent from "../../../../components/Listing/Listing";
import slugify from "slugify";
import prisma from "../../../../lib/prisma";
import SideNav from "../../../../components/SideNav/SideNav";
import NewFooter from "../../../../components/Footer/newFooter";
import { truncateString } from "../../../../utils/utilties";
import dynamic from "next/dynamic";
const ListingsComp = dynamic(() => import("../../../../components/listings"), { ssr: true });

import {
  AllBusiness,
  groupedBusiness,
  propertyTypeOptions,
  provinceSlugs,
  subTypeOptions,
} from "../../../../components/Listing/data";

import { getAreaDescriptionWithSlug } from "../../../../lib/api";
import { SpinnerHolder } from "../../../../styles/ListingsStyles";
import { shuffle, toProperCase } from "../../../../src/apiUtility";
import { provinceShorter } from "../../../../components/ListingCard/ListingCard2point0";
import {
  generateListingFooterText,
  getCityListingsByPropertyType,
  IGetStaticProps,
  StaticListingPageProps,
} from "..";
import { ParsedUrlQuery } from "querystring";
import { QueryStateContext } from "../../../../utils/contexts/QueryStateContext";
String.prototype["toProperCase"] = function () {
  return this.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

interface RouteParams extends ParsedUrlQuery {
  id: string;
  name: string;
}
interface IndividualListingPageprops {
  fListing;
  relevantListings;
  sortedAllListings;
  sortedBusinessListingsInCity;
  avgResponseTimeInDays: number | null;
  otherFromPoster;
  ogImg;
  ogFound;
}

function Listing({
  fListing,
  otherFromPoster,
  sortedAllListings,
  sortedBusinessListingsInCity,
  avgResponseTimeInDays,
  relevantListings,
  ogImg,
  staticDesc,
  ogFound,
  listings,
  countOfListings,
  coordinates,
  startListing,
  lastListing,
  pages,
  staticType,
  staticTypeValue,
  cityListingsByPropertyType,
  cleanedVariable,
  cleanedName,
  currentPage,
  description,
  linkList1,
  linkList1Header,
  staticHeader,
  linkList2,
  linkList2Header,
  metaDesc,
  metaTitle,
  province,
  city,
  businessCategoryValue,
  businessTypeValue,
  subTypeValue,
  propertyTypeValue,
  subTypeGroup,
  businessTypeGroup,
  listingFooterText,
}: StaticListingPageProps & IndividualListingPageprops) {
  const router = useRouter();
  const { queryState, setQueryState } = useContext(QueryStateContext)

  useEffect(() => {
    if (listings && cleanedVariable) {
        // Update the query state to update the filter badges when the page footer links are clicked
        setQueryState({
            ...queryState,
            [staticType]: [staticTypeValue], 
            province,
        })
    }
}, [listings, cleanedVariable])

  if (router.isFallback) {
    return (
      <Flex
        width="100%"
        justifyContent="space-between"
        className={"loaderHome"}
      >
        <SpinnerHolder>
          <Spinner size="xl" color="green.800" />
        </SpinnerHolder>
      </Flex>
    );
  }

  const { id } = router.query;
  //   When it's a listing
  // @ts-ignore
  if (!isNaN(id)) {
    if (fListing.status === "pending") {
      return (
        <>
          <Head>
            <meta name="robots" content="noindex, nofollow" />
          </Head>
          <Box
            h="90vh"
            paddingTop="20px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <h1>
              This listing is under review and will be visible once approved.
            </h1>
          </Box>
        </>
      );
    }

    const canonicalUrl = `https://zonado.com/listings/${id}/${slugify(
      fListing.subject
    )}`;
    const pageTitle = `${fListing.subject.toProperCase()} | zonado.com`;
    const listingDescription = fListing.metaDescription || truncateString(fListing.marketing, 147);
    const structuredDataImages =
      fListing.imageURLs?.length > 0 ? fListing.imageURLs : [ogImg];

    return (
      <>
        <Head>
          <title key="title">{pageTitle}</title>
          <meta
            key="description"
            name="description"
            content={listingDescription}
          />
          <meta name="author" content={fListing?.User?.fullName} />
          <meta name="date" content={fListing.timeStamp} />
          <meta key="og:title" property="og:title" content={pageTitle} />
          <meta
            key="og:description"
            property="og:description"
            content={listingDescription}
          />
          <meta key="og:image" property="og:image" content={ogImg} />
          <meta key="og:url" property="og:url" content={canonicalUrl} />
          <meta property="og:type" content="article" />
          <meta
            property="article:published_time"
            content={fListing.timeStamp}
          />
          <meta
            property="article:modified_time"
            content={fListing.modifiedTimeStamp}
          />
          <meta property="article:author" content={fListing?.User?.fullName} />
          <meta property="og:site_name" content="Zonado" />
          <meta
            key="twitter:card"
            name="twitter:card"
            content="summary_large_image"
          />
          <meta key="twitter:title" name="twitter:title" content={pageTitle} />
          <meta
            key="twitter:description"
            name="twitter:description"
            content={listingDescription}
          />
          <meta key="twitter:image" name="twitter:image" content={ogImg} />
          <link
            key="fav1"
            rel="apple-touch-icon"
            sizes="180x180"
            href="../../favicons/apple-touch-icon.png"
          />
          <link
            key="fav2"
            rel="icon"
            type="image/png"
            sizes="32x32"
            href="../../favicons/favicon-32x32.png"
          />
          <link
            key="fav3"
            rel="icon"
            type="image/png"
            sizes="16x16"
            href="../../favicons/favicon-16x16.png"
          />
          <link
            key="fav4"
            rel="manifest"
            href="../../favicons/site.webmanifest"
          />
          <link
            key="fav5"
            rel="mask-icon"
            href="../../favicons/safari-pinned-tab.svg"
            color="#125f3f"
          />
          <link
            key="fav6"
            rel="shortcut icon"
            href="../../favicons/favicon.ico"
          />
          <link rel="canonical" href={canonicalUrl} />
          <meta
            key="msFav"
            name="msapplication-config"
            content="../../favicons/browserconfig.xml"
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Product",
                sku: `${fListing.id}`,
                name: fListing.subject,
                description: listingDescription,
                image: structuredDataImages,
                brand: { "@type": "Organization", name: "Zonado" },
                offers: {
                  "@type": "Offer",
                  url: canonicalUrl,
                  priceCurrency: "CAD",
                  price: fListing.unpriced ? undefined : fListing.price,
                  availability: fListing.offMarket
                    ? "https://schema.org/SoldOut"
                    : "https://schema.org/InStock",
                  itemCondition: "https://schema.org/UsedCondition",
                },
                additionalProperty: [
                  fListing.address && fListing.showAddress
                    ? {
                        "@type": "PropertyValue",
                        name: "streetAddress",
                        value: fListing.address,
                      }
                    : null,
                  fListing.city
                    ? {
                        "@type": "PropertyValue",
                        name: "addressLocality",
                        value: fListing.city,
                      }
                    : null,
                  fListing.province
                    ? {
                        "@type": "PropertyValue",
                        name: "addressRegion",
                        value: fListing.province,
                      }
                    : null,
                  fListing.sqft
                    ? {
                        "@type": "PropertyValue",
                        name: "floorSize",
                        value: `${fListing.sqft} sqft`,
                      }
                    : null,
                  fListing.type
                    ? {
                        "@type": "PropertyValue",
                        name: "listingType",
                        value: fListing.type,
                      }
                    : null,
                ].filter(Boolean),
              }),
            }}
          />
        </Head>

        {/* <NoSSR> */}

        <SideNav />
        <Overall>
          <ListingComponent
            id={id}
            fListing={fListing}
            otherFromPoster={otherFromPoster}
            sortedAllListings={sortedAllListings}
            avgResponseTimeInDays={avgResponseTimeInDays}
            relevantListings={relevantListings}
            sortedBusinessListingsInCity={sortedBusinessListingsInCity}
            primary={ogFound ? ogImg : null}
          />
          <NewFooter faq={false} isProfessional={false} />
        </Overall>
        {/* </NoSSR> */}
      </>
    );
  } else {
    return (
      <>
        <Head>
          {cleanedVariable && (
            <>
              <title key="title">{metaTitle}</title>
              <meta key="og:title" property="og:title" content={metaTitle} />
              <meta name="description" key="description" content={metaDesc} />
              <meta
                key="og:description"
                property="og:description"
                content={metaDesc}
              />
              <meta property="og:site_name" content="Zonado" />

              <meta
                name="robots"
                content={countOfListings == 0 ? "noindex" : ""}
              />
              <link
                key="fav1"
                rel="apple-touch-icon"
                sizes="180x180"
                href="../../favicons/apple-touch-icon.png"
              />
              <link
                key="fav2"
                rel="icon"
                type="image/png"
                sizes="32x32"
                href="../../favicons/favicon-32x32.png"
              />
              <link
                key="fav3"
                rel="icon"
                type="image/png"
                sizes="16x16"
                href="../../favicons/favicon-16x16.png"
              />
              <link
                key="fav4"
                rel="manifest"
                href="../../favicons/site.webmanifest"
              />
              <link
                key="fav5"
                rel="mask-icon"
                href="../../favicons/safari-pinned-tab.svg"
                color="#125f3f"
              />
              <link
                key="fav6"
                rel="shortcut icon"
                href="../../favicons/favicon.ico"
              />
              <link
                rel="canonical"
                href={`https://zonado.com/listings/${provinceShorter(
                  province
                )}/${city ? slugify(city) : slugify(cleanedName)}`}
              />
              <meta
                key="msFav"
                name="msapplication-config"
                content="../../favicons/browserconfig.xml"
              />
            </>
          )}
        </Head>
        {cleanedVariable ? (
          <ListingsComp
            linkList1={linkList1}
            linkList1Header={linkList1Header}
            linkList2={linkList2}
            linkList2Header={linkList2Header}
            staticHeader={staticHeader}
            query={
              { [staticType]: [staticTypeValue], province }
              // propertyTypeValue && province ?
              //   { propertyType: propertyTypeValue, province } :
              // province && subTypeValue ?
              //   { subType: subTypeValue, province } :
              // businessTypeValue && province ?
              //   { businessType: businessTypeValue, province } :
              //   { province, city }
            }
            staticType={staticType}
            cityListingsByPropertyType={cityListingsByPropertyType}
            description={description ? description["description"] : null}
            cleanedProvince={cleanedVariable}
            cleanedName={cleanedName}
            staticDesc={staticDesc}
            staticData={{
              listings,
              countOfListings,
              coordinates,
              startListing,
              lastListing,
              pages,
              currentPage,
            }}
            cleanedVariable={undefined}
            listingFooterText={listingFooterText}
            cleanedType={undefined}
            province={province}
            city={city}
            businessCategoryValue={businessCategoryValue}
            propertyTypeValue={propertyTypeValue}
            subTypeGroup={subTypeGroup}
            subTypeValue={subTypeValue}
            businessTypeGroup={businessTypeGroup}
            businessTypeValue={businessTypeValue}
          />
        ) : (
          <SpinnerHolder>
            <Spinner size="xl" color="green.800" />
          </SpinnerHolder>
        )}
      </>
    );
  }
}

export default Listing;
// export default withAuthModal(Listing);

export async function getStaticPaths() {
  const receivedListings = await prisma.listing.findMany({
    where: {
     id: 2436
    },
    select: {
      id: true,
      subject: true,
    },
  });

  const starterPaths = [
    {
      params: {
        id: "ON",
        name: "Office",
      },
    },
    {
      params: {
        id: "ON",
        name: "Toronto",
      },
    },
  ];

  receivedListings.forEach((doc) => {
    // let listingData = doc.data();
    // Random shortlisting to cut build times
    starterPaths.push({
      params: {
        id: doc.id.toString(),
        name: slugify(doc["subject"]),
      },
    });
  });

  return {
    paths: starterPaths,
    fallback: 'blocking',
  };
}

export const getStaticProps: IGetStaticProps<
  RouteParams,
  StaticListingPageProps | IndividualListingPageprops
> = async ({ params }) => {
  let cleanedVariable = params.id.replace(/-/g, " ").toUpperCase();

  // Its a listing page
  const idParamIsListingID = !isNaN(Number(params.id));
  if (idParamIsListingID) {
    const IdAsNumber = Number(params.id);

    const receivedListing = await prisma.listing.findUnique({
      where: {
        id: IdAsNumber,
      },
      include: {
        User: {
          include: {
            Listings: {
              where: {
                status: "Available",
              },
              select: {
                priceType: true,
                price: true,
                type: true,
                city: true,
                subject: true,
                id: true,
                primaryImg: true,
                imageOrder: true,
                imageURLs: true,
                imagesFresh: true,
                coordinates: true,
                priority: true,
              },
            },
          },
        },
        Unit: {
          orderBy: {
            id: "asc",
          }
        },
         // Include the coListers
         coListers: {
          select: {
              uid: true,
              fullName: true,
              title: true,
              brokerage: true,
              photoURL: true,
              industryRole: true,
              brokeragePhoto: true,
              slug: true,
              pro: true
  
          }
      },
        presentations: {
          where: {
            status: "Available",
          },
          select: {
            id: true,
          },
        },
        _count: {
          select: {
            Saved: true
          }
        }
      },
    });

    if (!receivedListing) {
      return {
        notFound: true,
      };
    }
    if (receivedListing && receivedListing.status === "deleted") {
      return {
        redirect: {
          destination: "/listings",
          permanent: true,
        },
      };
    }

    // The [name] segment is cosmetic/SEO only - the lookup above is keyed on
    // id alone. Without this check, any string works and gets rendered as a
    // brand new page, so a scraper permuting [name] (e.g. off scraped image
    // filenames) can force unlimited unique ISR builds - each one a fresh DB
    // hit - and blow through the connection pool. Redirect anything that
    // isn't the canonical slug before doing any further (expensive) work.
    const canonicalName = slugify(receivedListing.subject);
    if (params.name !== canonicalName) {
      return {
        redirect: {
          destination: `/listings/${params.id}/${canonicalName}`,
          permanent: true,
        },
      };
    }

    let fListing: typeof receivedListing = JSON.parse(
      JSON.stringify(receivedListing)
    );

    const {
      id,
      subType,
      propertyTypes,
      businessType,
      province,
      price,
      type,
      city,
      coordinates,
      primaryImg,
      User,
      imageURLs,
    } = fListing;

    let listingPrimaryImg;

    const fListingHasBusinessType =
      propertyTypes.includes("Sale of Business") && !!businessType;

    const similarListingsFetch = await prisma.listing.findMany({
      where: {
        status: "Available",
        OR: [
          {
            propertyTypes: {
              hasSome: propertyTypes,
            },
          },
          {
            businessType: fListingHasBusinessType ? businessType : undefined,
          },
        ],
        type: type,
        id: {
          not: id,
        },
      },
      select: {
        priceType: true,
        price: true,
        type: true,
        city: true,
        province: true,
        subject: true,
        id: true,
        primaryImg: true,
        imageOrder: true,
        imageURLs: true,
        imagesFresh: true,
        coordinates: true,
        businessType: true,
        businessCategory: true,
        propertyTypes: true,
        subTypes: true,
        totalBuildingSize: true,
        lotSize: true,
        lotSizeUnit: true,
        unpriced: true,
        offMarket: true,
        grossRevenue: true,
      },
    });

    const similarJson: typeof similarListingsFetch = JSON.parse(
      JSON.stringify(similarListingsFetch)
    );

    let similarListingsInCity = [];
    let similarListingsInProvince = [];
    let similarBusinessListingsInCity = [];
    let allListings = [];
    similarJson.forEach((listing) => {
      const listingHasSameBusinessType = listing.businessType === businessType;
      const hasSameProvince =
        !!province &&
        listing["province"]?.toLowerCase() === province.toLowerCase();
      const hasSameCity =
        !!city && listing["city"]?.toLowerCase() === city.toLowerCase();
      if (listing["coordinates"]) {
        const theseCoordinates = listing.coordinates as {
          lat: number;
          lng: number;
        };

        const checkPoint = coordinates as typeof theseCoordinates;
        const km = 200;

        var ky = 40000 / 360;
        var kx = Math.cos((Math.PI * theseCoordinates.lat) / 180.0) * ky;
        var dx = Math.abs(theseCoordinates.lng - checkPoint.lng) * kx;
        var dy = Math.abs(theseCoordinates.lat - checkPoint.lat) * ky;
        if (Math.sqrt(dx * dx + dy * dy) <= km || hasSameProvince) {
          if (fListingHasBusinessType && listingHasSameBusinessType) {
            similarBusinessListingsInCity.push(listing);
            return;
          }
          if (hasSameCity) {
            similarListingsInCity.push(listing);
            return;
          }
          similarListingsInProvince.push(listing);
        } else {
          // to avoid duplicate listings in similarBusinessListingsInCity and similarListingsInCity, only push listings that have similar property types, not business type
          allListings.push(listing);
        }

        // If not close, add distance to the listing
        listing["distance"] = dx * dx + dy * dy;
      }

      // Likely doesn't do anything, uncomment the console logs and refresh the page, nothing gets logged
      // if (
      //   !!province &&
      //   listing["province"]?.toLowerCase() === province.toLowerCase()
      // ) {
      //   // console.log('city', listing['city'])
      //   // console.log((fListingHasBusinessType && listingHasSameBusinessType))
      //   if (
      //     !!city &&
      //     listing["city"]?.toLowerCase() === city.toLowerCase()
      //   ) {
      //     similarListingsInCity.push(listing);
      //   } else {
      //     similarListingsInProvince.push(listing);
      //   }
      // } else {
      //   allListings.push(listing);
      // }
    });

    const sortedListingsInCity =
      similarListingsInCity.length > 0
        ? similarListingsInCity.sort(
            (a, b) => b["price"] - price - (price - a["price"])
          )
        : similarListingsInCity;

    const sortedListingsInProvince =
      similarListingsInProvince.length > 0
        ? similarListingsInProvince.sort(
            (a, b) => b["price"] - price - (price - a["price"])
          )
        : similarListingsInProvince;
    const sortedBusinessListingsInCity =
      similarBusinessListingsInCity.length > 0
        ? similarBusinessListingsInCity
            .sort((a, b) => b["price"] - price - (price - a["price"]))
            .slice(0, 15)
        : similarBusinessListingsInCity;

    const sortedAllListings = allListings
      .sort((a, b) => (b.distance < a.distance ? 1 : -1))
      .slice(0, 15);

    const relevantListings = [
      ...sortedListingsInCity,
      ...sortedListingsInProvince,
    ].slice(0, 12);
    // Both are sorted in terms of their gap from the price of the listing

    const { Listings, uid: listingOwnerUid } = User;

    let otherFromPoster = [];
    // See if there are other listings to include
    if (Listings.length > 1) {
      Listings.map((item) => {
        if (item["id"] != id) {
          otherFromPoster.push(item);
        }
      });
    }

    const listingOwnerConversations = await prisma.conversation.findMany({
      where: {
        users: {
          some: {
            uid: listingOwnerUid,
          },
        },
      },
      select: {
        Message: {
          take: 5,
          orderBy: {
            timeStamp: "asc",
          },
          select: {
            timeStamp: true,
            uid: true,
          },
        },
      },
    });

    let avgResponseTimeInDays = null;
    if (listingOwnerConversations.length) {
      const convosNotStartedByListingOwner = listingOwnerConversations.filter(
        (conversation) => {
          const firstMessage = conversation.Message[0];
          // console.log("firstMessage", firstMessage)
          const isNotByListingOwner = firstMessage?.uid !== listingOwnerUid;
          return isNotByListingOwner;
        }
      );

      const convosWithMsgsFromTwoUsers = convosNotStartedByListingOwner.filter(
        (conversation) => {
          const messageExistsByListingOwner = conversation.Message.find(
            ({ uid }) => uid === listingOwnerUid
          );
          return !!messageExistsByListingOwner;
        }
      );
      // console.log("convosWithMsgsFromTwoUsers", convosWithMsgsFromTwoUsers.map(c => c.Message.map(message => message.timeStamp)))

      const sumOfResponseTime = convosWithMsgsFromTwoUsers.length
        ? convosWithMsgsFromTwoUsers.reduce(
            (sumOfResponseTime, currentConversation, index) => {
              const firstMessageByListingOwner =
                currentConversation.Message.find(
                  (message) => message.uid === listingOwnerUid
                );
              const firstMessageTimeStampByListingOwner =
                firstMessageByListingOwner.timeStamp;
              const messageTimestampByOtherUser =
                currentConversation.Message[0].timeStamp;
              const responseTime =
                firstMessageTimeStampByListingOwner.getTime() -
                messageTimestampByOtherUser.getTime(); // no need to get the absolute value
              // const responseTimeInDays = responseTime / (1000 * 60 * 60 * 24);
              return sumOfResponseTime + responseTime;
            },
            0
          )
        : null;
      avgResponseTimeInDays = !!sumOfResponseTime
        ? Math.floor(
            sumOfResponseTime /
              convosWithMsgsFromTwoUsers.length /
              (1000 * 60 * 60 * 24)
          )
        : null;
    }

    // All of this type

    // In order of closeness to this one

    return {
      props: {
        fListing,
        relevantListings,
        sortedAllListings,
        sortedBusinessListingsInCity,
        otherFromPoster,
        avgResponseTimeInDays,
        ogImg:
          imageURLs.length > 0
            ? imageURLs[0]
            : "https://firebasestorage.googleapis.com/v0/b/goldmine-7d9f7.appspot.com/o/compressed%2Fog_1200x1200.png?alt=media&token=6ab21097-15f5-4e6c-88cf-d4989408d62f",
        ogFound: listingPrimaryImg || false,
      },

      revalidate: 3600, // In seconds
    };
  }

  // It's a province/[something]
  else if (
    provinceSlugs.some(
      (e) => e["slug"].toLowerCase() == cleanedVariable.toLowerCase()
    )
  ) {
    // This is either a city or a subtype
    const theProv = provinceSlugs.find(
      (i) => i["slug"].toLowerCase() == cleanedVariable.toLowerCase()
    );
    const { value: province } = theProv;

    // Check if this is a property type
    // /listings/Ontario/Office
    let cleanedName = toProperCase(params.name.replace(/-/g, " "));

    const propertyType = propertyTypeOptions.find(
      (e) => e["value"].toLowerCase() == cleanedName?.toLowerCase()
    );
    const subType = subTypeOptions
      .filter((subType) => subType.group.toLowerCase() !== "sale of business")
      .find(
        (e) =>
          e["value"].toLowerCase() == cleanedName?.toLowerCase() ||
          e["urlValue"]?.toLowerCase() == cleanedName.toLowerCase()
      );
    const businessType = AllBusiness.find((e) => {
      return (
        slugify(e["value"].toLowerCase()) == slugify(params.name.toLowerCase())
      );
    });

    const businessCategory = groupedBusiness.find(
      (e) => e["urlValue"].toLowerCase() === cleanedName.toLowerCase()
    );

    if (!!propertyType) {
      cleanedName = propertyType.value;
      const isSaleOfBusiness =
        propertyType.value.toLowerCase() === "sale of business";
      const businessOrPropType = isSaleOfBusiness
        ? `Businesses for sale`
        : `${cleanedName} listings`;
      // Get actual provinces

      const description = await getAreaDescriptionWithSlug(
        cleanedVariable.toLowerCase()
      );
      const listings = await prisma.listing.findMany({
        where: {
          status: "Available",
          propertyTypes: {
            has: cleanedName,
          },
          province: {
            equals: province,
            mode: "insensitive",
          },
        },
        take: 60,
        skip: undefined,

        select: {
          id: true,
          subject: true,
          subType: true,
          propertyTypes: true,
          type: true,
          priceType: true,
          city: true,
          price: true,
          unpriced: true,
          offMarket: true,
          imageOrder: true,
          imageURLs: true,
          imagesFresh: true,
          showAddress: true,

          timeStamp: true,
          primaryImg: true,
          bedrooms: true,
          sqft: true,
          totalBuildingSize: true,
          lotSize: true,
          lotSizeUnit: true,
          cap: true,
          province: true,
          priority: true,
          aiTagline: true,
          distressed: true,
          grossRevenue: true,
          ebitda: true,
          employees: true,
          yearEstablished: true,
          businessType: true,
          businessCategory: true,
          User: {
            select: {
              brokerage: true,
              industryRole: true,
              pro: true,
              plan: true,
              fullName: true,
              photoURL: true,
            },
          },
        },
        orderBy: [{ priority: "desc" }, { timeStamp: "desc" }],
      });

      const nonProListings = listings.filter(
        (listing) => listing["priority"] === 1
      );
      const proListings = shuffle(
        listings.filter((listing) => listing["priority"] > 1)
      );
      const proSortedListings = [...proListings, ...nonProListings];

      const coordinates = await prisma.listing.findMany({
        where: {
          status: "Available",
          propertyTypes: {
            has: cleanedName,
          },
          province: {
            equals: province,
            mode: "insensitive",
          },
        },
        select: {
          coordinates: true,
          id: true,
        },
      });

      const aggregations = await prisma.listing.aggregate({
        where: {
          status: "Available",
          propertyTypes: {
            has: cleanedName,
          },
          province: {
            equals: province,
            mode: "insensitive",
          },
        },
        _count: {
          _all: true,
        },
      });

      // Coordinates need to be sent for all listings that match criteria in where, regardless of whether or not they were on this page
      // Meaning where needs to be used in multiple places

      // Desctucture aggregations before returning
      const {
        _count: { _all: countOfListings },
      } = aggregations;

      // Office listings in Ontario

      const thisProvCities = await prisma.listing.groupBy({
        where: {
          status: "Available",
          province: {
            equals: province,
            mode: "insensitive",
          },
          propertyTypes: {
            has: cleanedName,
          },
          city: {
            not: null,
          },
        },
        by: ["city"],
        _count: {
          _all: true,
        },
        orderBy: {
          _count: {
            city: "desc",
          },
        },
      });

      // Types in this province

      let linkList1 = [];
      const linkList1Header = `${businessOrPropType} in ${province}`;
      thisProvCities.map(async (i) => {
        const {
          city: item,
          _count: { _all: itemCount },
        } = i;
        if (item && itemCount) {
          const formattedCityName = toProperCase(item.replace(/-/g, ' '))
          const theObj = {
            item,
            itemCount,
            link: `/listings/${cleanedVariable}/${slugify(formattedCityName)}/${slugify(
              cleanedName
            )}`,
          };
          linkList1.push(theObj);
        }
      });

      const subTypesInListingPropertyType: typeof subTypeOptions =
        subTypeOptions.filter(
          (subTypeOption) => subTypeOption.group === cleanedName
        );
      const listingsWithSubTypesInPropType = [];
      const listingsWithOtherPropertyTypes = [];
      const otherPropertyTypes = propertyTypeOptions.filter(
        (propertyTypeOption) => propertyTypeOption.value !== cleanedName
      );

      for (var a = 0; a <= subTypesInListingPropertyType.length; a++) {
        if (a == subTypesInListingPropertyType.length) {
          // sort
          listingsWithSubTypesInPropType.sort(
            (a, b) => b.itemCount - a.itemCount
          );
        } else {
          const { value: subType, urlValue } = subTypesInListingPropertyType[a];
          const listingWithSubTypeCount = await prisma.listing.count({
            where: {
              status: "Available",
              subTypes: {
                has: subType,
              },
              // propertyTypes: {
              //   has: cleanedName,
              // },
              province: {
                equals: province,
                mode: "insensitive",
              },
            },
            // by: ['propertyTypes'],
          });
          if (listingWithSubTypeCount > 0) {
            listingsWithSubTypesInPropType.push({
              item: subType,
              itemCount: listingWithSubTypeCount,
              link: `/listings/${cleanedVariable}/${slugify(
                urlValue || subType
              )}`,
              // type: subType, count: listingWithSubTypeCount
            });
          }
        }
      }

      for (let index = 0; index <= otherPropertyTypes.length; index++) {
        if (index === otherPropertyTypes.length) {
          // sort
          listingsWithOtherPropertyTypes.sort(
            (a, b) => b.itemCount - a.itemCount
          );
        } else {
          const { value: propertyType } = otherPropertyTypes[index];
          const listingsWithPropTypeCount = await prisma.listing.count({
            where: {
              propertyTypes: {
                has: propertyType,
              },
              province: {
                equals: province,
                mode: "insensitive",
              },
            },
          });

          if (listingsWithPropTypeCount > 0) {
            listingsWithOtherPropertyTypes.push({
              item: propertyType,
              itemCount: listingsWithPropTypeCount,
              link: `/listings/${cleanedVariable}/${slugify(propertyType)}`,
              // type: propertyType,
              // count: listingsWithPropTypeCount
            });
          }
        }
      }

      const linkList2Header = `${province} Listing Types`;
      const linkList2 = [
        ...listingsWithSubTypesInPropType,
        ...listingsWithOtherPropertyTypes,
      ];

      // listingsWithSubTypesInPropType.map(async (i) => {
      //   const { type: item, count: itemCount } = i;
      //   if (item && itemCount) {
      //     const theObj = {
      //       item,
      //       itemCount,
      //       link: `/listings/${cleanedVariable}/${slugify(item)}`,
      //     };
      //     linkList2.push(theObj);
      //   }
      // });

      const cityListingsByPropertyType = getCityListingsByPropertyType(
        thisProvCities,
        listings,
        province
      );

      const staticDesc = `Looking for ${businessOrPropType} in ${province}? There are ${countOfListings} ${businessOrPropType} from across ${province} available on Zonado. Sort and filter results to find the perfect opportunity.`;

      const metaTitle = `${
        isSaleOfBusiness
          ? "Businesses for Sale"
          : `${cleanedName?.toProperCase()} Listings`
      } in ${province} | ${countOfListings} currently available | zonado.com`;
      const metaDesc = `Search ${businessOrPropType} in ${province}, review due diligence & submit offers on commercial properties. Over ${countOfListings} ${
        isSaleOfBusiness ? "businesses" : `${cleanedName} properties`
      } currently available.`;

      const staticHeader = `${
        isSaleOfBusiness
          ? "Businesses for Sale"
          : `${cleanedName?.toProperCase()} Listings`
      } in ${province}`;

      // Ontario property types

      return {
        props: {
          cleanedVariable: province,
          cleanedName,
          province,
          propertyTypeValue: cleanedName,
          staticDesc: staticDesc,
          metaDesc,
          metaTitle,
          staticHeader,
          listings: JSON.parse(JSON.stringify(proSortedListings)),
          countOfListings,
          coordinates,
          startListing: 1,
          lastListing: countOfListings > 60 ? 60 : countOfListings,
          pages: Math.ceil(countOfListings / 60),
          description: description ? description : null,
          staticType: "propertyType",
          staticTypeValue: cleanedName,
          cityListingsByPropertyType,
          listingFooterText:
            generateListingFooterText().forPropertyTypeOrSubTypePage(),
          currentPage: 1,
          linkList1,
          linkList1Header,
          linkList2,
          linkList2Header,
        },
        revalidate: 3600, // In seconds
      };
    } else if (!!subType || !!businessType) {
      const { value: cleanedName, urlValue } = !!businessType
        ? businessType
        : subType;
      const urlValueType = urlValue || cleanedName;
      const listingTypeQuery = !!businessType
        ? {
            businessType: cleanedName,
          }
        : {
            OR: [
              {
                businessType: cleanedName,
              },
              {
                subTypes: {
                  has: cleanedName,
                },
              }
            ]
          }
      const description = await getAreaDescriptionWithSlug(
        cleanedVariable.toLowerCase()
      );
      const listings = await prisma.listing.findMany({
        where: {
          status: "Available",
          ...listingTypeQuery,
          province: {
            equals: province,
            mode: "insensitive",
          },
        },
        take: 60,
        skip: undefined,

        select: {
          id: true,
          subject: true,
          subType: true,
          propertyTypes: true,
          type: true,
          priceType: true,
          city: true,
          price: true,
          unpriced: true,
          offMarket: true,
          imageOrder: true,
          imageURLs: true,
          imagesFresh: true,
          showAddress: true,

          timeStamp: true,
          primaryImg: true,
          bedrooms: true,
          sqft: true,
          totalBuildingSize: true,
          lotSize: true,
          lotSizeUnit: true,
          cap: true,
          province: true,
          priority: true,
          aiTagline: true,
          distressed: true,
          grossRevenue: true,
          ebitda: true,
          employees: true,
          yearEstablished: true,
          businessType: true,
          businessCategory: true,
          User: {
            select: {
              brokerage: true,
              industryRole: true,
              pro: true,
              plan: true,
              fullName: true,
              photoURL: true,
            },
          },
        },
        orderBy: [{ priority: "desc" }, { timeStamp: "desc" }],
      });

      const nonProListings = listings.filter(
        (listing) => listing["priority"] === 1
      );
      const proListings = shuffle(
        listings.filter((listing) => listing["priority"] > 1)
      );
      const proSortedListings = [...proListings, ...nonProListings];

      const coordinates = await prisma.listing.findMany({
        where: {
          status: "Available",
          ...listingTypeQuery,
          province: {
            equals: province,
            mode: "insensitive",
          },
        },
        select: {
          coordinates: true,
          id: true,
        },
      });

      const aggregations = await prisma.listing.aggregate({
        where: {
          status: "Available",
          ...listingTypeQuery,
          province: {
            equals: province,
            mode: "insensitive",
          },
        },
        _count: {
          _all: true,
        },
      });

      // Coordinates need to be sent for all listings that match criteria in where, regardless of whether or not they were on this page
      // Meaning where needs to be used in multiple places

      // Desctucture aggregations before returning
      const {
        _count: { _all: countOfListings },
      } = aggregations;

      // Office listings in Ontario

      const thisProvCities = await prisma.listing.groupBy({
        where: {
          status: "Available",
          province: {
            equals: province,
            mode: "insensitive",
          },
          ...listingTypeQuery,
          city: {
            not: null,
          },
        },
        by: ["city"],
        _count: {
          _all: true,
        },
        orderBy: {
          _count: {
            city: "desc",
          },
        },
      });

      // Types in this province

      let linkList1 = [];
      const linkList1Header = `${urlValueType} listings in ${province}`;
      thisProvCities.map(async (i) => {
        const {
          city: item,
          _count: { _all: itemCount },
        } = i;
        if (item && itemCount) {
          const formattedCityName = toProperCase(item.replace(/-/g, ' '))
          const theObj = {
            item,
            itemCount,
            link: `/listings/${cleanedVariable}/${slugify(formattedCityName)}/${slugify(
              urlValueType
            )}`,
          };
          linkList1.push(theObj);
        }
      });

      let newAllASubTypes = [];
      for (var a = 0; a <= propertyTypeOptions.length; a++) {
        if (a == propertyTypeOptions.length) {
          // sort
          newAllASubTypes.sort((a, b) => b.count - a.count);
        } else {
          const type = propertyTypeOptions[a]["value"];
          const fetchType = await prisma.listing.count({
            where: {
              status: "Available",
              propertyTypes: {
                has: type,
              },
              province: {
                equals: province,
                mode: "insensitive",
              },
            },
            // by: ['propertyTypes'],
          });
          newAllASubTypes.push({ type, count: fetchType });
        }
      }

      // const thisProvSubTypes = await prisma.listing.groupBy({
      //     where: {
      //         status: 'Available',
      //         province: {
      //             equals: province,
      //             mode: 'insensitive'
      //         },
      //         subType: {
      //             not: undefined
      //         }
      //     },
      //     by: ['subType'],
      //     _count: {
      //         _all: true,
      //     },
      //     orderBy: {
      //         _count: {
      //             subType: 'desc'
      //         }
      //     }
      // })

      let linkList2 = [];
      const linkList2Header = `${province} Listing Types`;

      newAllASubTypes.map(async (i) => {
        const { type: item, count: itemCount } = i;
        if (item && itemCount) {
          const theObj = {
            item,
            itemCount,
            link: `/listings/${cleanedVariable}/${slugify(item)}`,
          };
          linkList2.push(theObj);
        }
      });

      const cityListingsByPropertyType = getCityListingsByPropertyType(
        thisProvCities,
        listings,
        province
      );

      const staticDesc = `Looking for ${urlValueType} listings in ${province}? There are ${countOfListings} ${urlValueType} listings from across ${province} available on Zonado. Sort and filter results to find the perfect opportunity.`;

      const metaTitle = `${urlValueType} listings in ${province} | ${countOfListings} currently available | zonado.com`;
      const metaDesc = `Search ${urlValueType} listings in ${province}, review due diligence & submit offers on commercial properties. Over ${countOfListings} ${urlValueType} properties currently available.`;

      const staticHeader = `${urlValueType?.toProperCase()} listings in ${province}`;

      // Ontario property types
      return {
        props: {
          cleanedVariable: province,
          cleanedName: urlValueType,
          province,
          [!!businessType ? "businessTypeValue" : "subTypeValue"]: cleanedName,
          staticDesc: staticDesc,
          metaDesc,
          metaTitle,
          staticHeader,
          listings: JSON.parse(JSON.stringify(proSortedListings)),
          countOfListings,
          coordinates,
          startListing: 1,
          lastListing: countOfListings > 60 ? 60 : countOfListings,
          pages: Math.ceil(countOfListings / 60),
          description: description ? description : null,
          staticType: !!businessType ? "businessType" : "subType",
          staticTypeValue: cleanedName,
          [!!businessType ? "businessTypeGroup" : "subTypeGroup"]:
            !!businessType ? businessType.group : subType.group,
          listingFooterText: !!businessType
            ? generateListingFooterText().forBusinessPage()
            : generateListingFooterText().forPropertyTypeOrSubTypePage(),
          cityListingsByPropertyType,
          currentPage: 1,
          linkList1,
          linkList1Header,
          linkList2,
          linkList2Header,
        },
        revalidate: 3600, // In seconds
      };
    } else if (!!businessCategory) {
      const { label: cleanedName, urlValue } = businessCategory;
      const urlValueType = urlValue || cleanedName;

      const description = await getAreaDescriptionWithSlug(
        cleanedVariable.toLowerCase()
      );
      const listings = await prisma.listing.findMany({
        where: {
          status: "Available",
          businessCategory: cleanedName,
          province: {
            equals: province,
            mode: "insensitive",
          },
        },
        take: 60,
        skip: undefined,

        select: {
          id: true,
          subject: true,
          subType: true,
          propertyTypes: true,
          type: true,
          priceType: true,
          city: true,
          price: true,
          unpriced: true,
          offMarket: true,
          imageOrder: true,
          imageURLs: true,
          imagesFresh: true,
          showAddress: true,

          timeStamp: true,
          primaryImg: true,
          bedrooms: true,
          sqft: true,
          totalBuildingSize: true,
          lotSize: true,
          lotSizeUnit: true,
          cap: true,
          province: true,
          priority: true,
          aiTagline: true,
          distressed: true,
          grossRevenue: true,
          ebitda: true,
          employees: true,
          yearEstablished: true,
          businessType: true,
          businessCategory: true,
          User: {
            select: {
              brokerage: true,
              industryRole: true,
              pro: true,
              plan: true,
              fullName: true,
              photoURL: true,
            },
          },
        },
        orderBy: [{ priority: "desc" }, { timeStamp: "desc" }],
      });

      const nonProListings = listings.filter(
        (listing) => listing["priority"] === 1
      );
      const proListings = shuffle(
        listings.filter((listing) => listing["priority"] > 1)
      );
      const proSortedListings = [...proListings, ...nonProListings];

      const coordinates = await prisma.listing.findMany({
        where: {
          status: "Available",
          businessCategory: cleanedName,
          province: {
            equals: province,
            mode: "insensitive",
          },
        },
        select: {
          coordinates: true,
          id: true,
        },
      });

      const aggregations = await prisma.listing.aggregate({
        where: {
          status: "Available",
          businessCategory: cleanedName,
          province: {
            equals: province,
            mode: "insensitive",
          },
        },
        _count: {
          _all: true,
        },
      });

      // Coordinates need to be sent for all listings that match criteria in where, regardless of whether or not they were on this page
      // Meaning where needs to be used in multiple places

      // Desctucture aggregations before returning
      const {
        _count: { _all: countOfListings },
      } = aggregations;

      // Office listings in Ontario

      const thisProvCities = await prisma.listing.groupBy({
        where: {
          status: "Available",
          province: {
            equals: province,
            mode: "insensitive",
          },
          businessCategory: cleanedName,
          city: {
            not: null,
          },
        },
        by: ["city"],
        _count: {
          _all: true,
        },
        orderBy: {
          _count: {
            city: "desc",
          },
        },
      });

      // Types in this province

      let linkList1 = [];
      const linkList1Header = `${urlValueType} listings in ${province}`;
      thisProvCities.map(async (i) => {
        const {
          city: item,
          _count: { _all: itemCount },
        } = i;
        if (item && itemCount) {
          const formattedCityName = toProperCase(item.replace(/-/g, ' '))
          const theObj = {
            item,
            itemCount,
            link: `/listings/${cleanedVariable}/${slugify(formattedCityName)}/${slugify(
              urlValueType
            )}`,
          };
          linkList1.push(theObj);
        }
      });

      let newAllASubTypes = [];
      for (var a = 0; a <= propertyTypeOptions.length; a++) {
        if (a == propertyTypeOptions.length) {
          // sort
          newAllASubTypes.sort((a, b) => b.count - a.count);
        } else {
          const { value: type, urlValue } = propertyTypeOptions[a];
          const fetchType = await prisma.listing.count({
            where: {
              status: "Available",
              propertyTypes: {
                has: type,
              },
              province: {
                equals: province,
                mode: "insensitive",
              },
            },
            // by: ['propertyTypes'],
          });
          newAllASubTypes.push({ type: urlValue || type, count: fetchType });
        }
      }

      // const thisProvSubTypes = await prisma.listing.groupBy({
      //     where: {
      //         status: 'Available',
      //         province: {
      //             equals: province,
      //             mode: 'insensitive'
      //         },
      //         subType: {
      //             not: undefined
      //         }
      //     },
      //     by: ['subType'],
      //     _count: {
      //         _all: true,
      //     },
      //     orderBy: {
      //         _count: {
      //             subType: 'desc'
      //         }
      //     }
      // })

      let linkList2 = [];
      const linkList2Header = `${province} Listing Types`;

      newAllASubTypes.map(async (i) => {
        const { type: item, count: itemCount } = i;
        if (item && itemCount) {
          const theObj = {
            item,
            itemCount,
            link: `/listings/${cleanedVariable}/${slugify(item)}`,
          };
          linkList2.push(theObj);
        }
      });

      const cityListingsByPropertyType = getCityListingsByPropertyType(
        thisProvCities,
        listings,
        province
      );

      const businessName = urlValueType.toLowerCase().includes("business")
        ? urlValueType
        : `${urlValueType} Businesses`;
      const staticDesc = `Looking for ${businessName} in ${province}? There are ${countOfListings} ${businessName} from across ${province} available on Zonado. Sort and filter results to find the perfect opportunity.`;

      const metaTitle = `${businessName} | ${countOfListings} currently available | zonado.com`;
      const metaDesc = `Search ${businessName} in ${province}. Review due diligence & submit offers on commercial properties. Over ${countOfListings} ${businessName} currently available.`;

      const staticHeader = `${businessName} in ${province} for Sale`;

      // Ontario property types

      return {
        props: {
          cleanedVariable: province,
          cleanedName: urlValueType,
          province,
          businessCategoryValue: cleanedName,
          staticDesc: staticDesc,
          metaDesc,
          metaTitle,
          staticHeader,
          listings: JSON.parse(JSON.stringify(proSortedListings)),
          countOfListings,
          coordinates,
          startListing: 1,
          lastListing: countOfListings > 60 ? 60 : countOfListings,
          pages: Math.ceil(countOfListings / 60),
          description: description ? description : null,
          staticType: "businessCategory",
          staticTypeValue: cleanedName,
          listingFooterText: generateListingFooterText().forBusinessPage(),
          cityListingsByPropertyType,
          currentPage: 1,
          linkList1,
          linkList1Header,
          linkList2,
          linkList2Header,
        },
        revalidate: 3600, // In seconds
      };
    }

    // It's a city
    // /listings/Ontario/Toronto
    else {
      const description = await getAreaDescriptionWithSlug(
        `${cleanedName?.toLowerCase()}-${cleanedVariable.toLowerCase()}`
      );

      let accentName = "gibberish";
      // If the province is Quebec, get a list of distinct cities that have accent e in them
      if (province == "Québec") {
        const accentCities = await prisma.listing.findMany({
          where: {
            status: "Available",
            province: province,
            OR: [
              {
                city: {
                  contains: "â",
                  mode: "insensitive",
                },
              },
              {
                city: {
                  contains: "é",
                  mode: "insensitive",
                },
              },
            ],
          },
          distinct: ["city"],
          select: {
            city: true,
          },
        });

        // See if the city name fuzzy matches any of these
        const properCity = accentCities.find(
          (ac) => slugify(ac["city"]) == slugify(cleanedName)
        );

        accentName = properCity?.city;
      }

      const listings = await prisma.listing.findMany({
        where: {
          status: "Available",
          OR: [
            {
              city: {
                contains: accentName,
                mode: "insensitive",
              },
            },
            {
              city: {
                contains: cleanedName,
                mode: "insensitive",
              },
            },
            {
              city: {
                contains: params.name,
                mode: "insensitive",
              },
            },
          ],

          // province: {
          //     equals: province,
          //     mode: 'insensitive'
          // }
        },
        take: 60,
        skip: undefined,

        select: {
          id: true,
          subject: true,
          subType: true,
          propertyTypes: true,
          type: true,
          priceType: true,
          city: true,
          price: true,
          unpriced: true,
          offMarket: true,
          imageOrder: true,
          imageURLs: true,
          imagesFresh: true,
          showAddress: true,

          timeStamp: true,
          primaryImg: true,
          bedrooms: true,
          sqft: true,
          totalBuildingSize: true,
          lotSize: true,
          lotSizeUnit: true,
          cap: true,
          province: true,
          priority: true,
          aiTagline: true,
          distressed: true,
          grossRevenue: true,
          ebitda: true,
          employees: true,
          yearEstablished: true,
          businessType: true,
          businessCategory: true,
          User: {
            select: {
              brokerage: true,
              industryRole: true,
              pro: true,
              plan: true,
              fullName: true,
              photoURL: true,
            },
          },
        },
        orderBy: [{ priority: "desc" }, { timeStamp: "desc" }],
      });

      const nonProListings = listings.filter(
        (listing) => listing["priority"] === 1
      );
      const proListings = shuffle(
        listings.filter((listing) => listing["priority"] > 1)
      );
      const proSortedListings = [...proListings, ...nonProListings];

      const coordinates = await prisma.listing.findMany({
        where: {
          status: "Available",
          OR: [
            {
              city: {
                contains: accentName,
                mode: "insensitive",
              },
            },
            {
              city: {
                contains: cleanedName,
                mode: "insensitive",
              },
            },
            {
              city: {
                contains: params.name,
                mode: "insensitive",
              },
            },
          ],
          // province: {
          //     equals: province,
          //     mode: 'insensitive'
          // }
        },
        select: {
          coordinates: true,
          id: true,
        },
      });

      const aggregations = await prisma.listing.aggregate({
        where: {
          status: "Available",
          OR: [
            {
              city: {
                contains: accentName,
                mode: "insensitive",
              },
            },
            {
              city: {
                contains: cleanedName,
                mode: "insensitive",
              },
            },
            {
              city: {
                contains: params.name,
                mode: "insensitive",
              },
            },
          ],
          // province: {
          //     equals: province,
          //     mode: 'insensitive'
          // },
        },
        _count: {
          _all: true,
        },
      });

      // Coordinates need to be sent for all listings that match criteria in where, regardless of whether or not they were on this page
      // Meaning where needs to be used in multiple places

      // Desctucture aggregations before returning
      const {
        _count: { _all: countOfListings },
      } = aggregations;

      // Listing types in City

      let newAllASubTypes = [];

      for (var a = 0; a <= propertyTypeOptions.length; a++) {
        if (a == propertyTypeOptions.length) {
          // sort
          newAllASubTypes.sort((a, b) => b.count - a.count);
        } else {
          const type = propertyTypeOptions[a]["value"];
          const fetchType = await prisma.listing.count({
            where: {
              status: "Available",
              propertyTypes: {
                has: type,
              },
              OR: [
                {
                  city: {
                    contains: accentName,
                    mode: "insensitive",
                  },
                },
                {
                  city: {
                    contains: cleanedName,
                    mode: "insensitive",
                  },
                },
                {
                  city: {
                    contains: params.name,
                    mode: "insensitive",
                  },
                },
              ],
            },
            // by: ['propertyTypes'],
          });
          newAllASubTypes.push({ type, count: fetchType });
        }
      }
      // const thisCitySubTypes = await prisma.listing.groupBy({
      //     where: {
      //         status: 'Available',
      //         city: {
      //             equals: cleanedName,
      //             mode: 'insensitive'
      //         },
      //         subType: {
      //             not: undefined
      //         }
      //     },
      //     by: ['subType'],
      //     _count: {
      //         _all: true,
      //     },
      //     orderBy: {
      //         _count: {
      //             subType: 'desc'
      //         }
      //     }
      // })

      let linkList1 = [];
      let linkList2 = [];
      const linkList1Header = `${cleanedName} Listing Types`;

      newAllASubTypes.map(async (i) => {
        const { type: item, count: itemCount } = i;
        if (item && itemCount) {
          const theObj = {
            item,
            itemCount,
            link: `/listings/${cleanedVariable}/${slugify(
              cleanedName
            )}/${slugify((item))}`,
          };
          linkList1.push(theObj);
        }
      });

      const staticHeader = `${cleanedName?.toProperCase()} Businesses and Commercial Real Estate`;

      const thisProvCities = await prisma.listing.groupBy({
        where: {
          status: "Available",
          province: {
            equals: province,
            mode: "insensitive",
          },
          city: {
            not: null,
          },
        },
        by: ["city"],
        _count: {
          _all: true,
        },
        orderBy: {
          _count: {
            city: "desc",
          },
        },
      });

      // Types in this province

      const linkList2Header = `Other Markets around ${cleanedName}`;
      thisProvCities.map(async (i) => {
        const {
          city: item,
          _count: { _all: itemCount },
        } = i;
        if (item && itemCount) {
          const formattedCityName = toProperCase(item.replace(/-/g, ' '))
          const theObj = {
            item,
            itemCount,
            link: `/listings/${cleanedVariable}/${slugify(formattedCityName)}`, // Make the city listing link like 
          };
          linkList2.push(theObj);
        }
      });

      const staticDesc = `Looking for a business or commercial real estate in ${cleanedName}? Search ${countOfListings} listings from across the city. From Land to Retail to Industrial properties, Zonado is your one-stop-shop to find a business or commercial real estate in ${cleanedName}.`;
      const metaTitle = `${cleanedName?.toProperCase()} Business and Commercial Real Estate Listings | ${countOfListings} currently available | zonado.com`;

      const metaDesc = `Search ${cleanedName} businesses and commercial real estate listings, review due diligence & submit offers on commercial properties. Over ${countOfListings} properties currently available.`;

      return {
        props: {
          cleanedVariable: province,
          cleanedName,
          province,
          city: cleanedName,
          staticType: "city",
          staticTypeValue: cleanedName,
          listings: JSON.parse(JSON.stringify(proSortedListings)),
          countOfListings,
          coordinates,
          startListing: 1,
          lastListing: countOfListings > 60 ? 60 : countOfListings,
          pages: Math.ceil(countOfListings / 60),
          description: description ? description : null,
          staticDesc,
          metaDesc,
          metaTitle,
          currentPage: 1,
          linkList1,
          linkList1Header,
          staticHeader,
          listingFooterText: generateListingFooterText().forCityPage(
            cleanedName,
            province,
            countOfListings
          ),
          linkList2: linkList2,
          linkList2Header: linkList2Header,
        },
        revalidate: 3600, // In seconds
      };
    }
  } else {
    return {
      notFound: true,
    };
  }
};
